'use client'

import { Icon, IconComponent } from '@graftcode/design-system'

import { MOBILE_MENU_TEST_IDS } from '@common/common-test-ids.const'

import { useMobileMenuContext } from '../../context'

import styles from '../../MobileMenu.module.scss'

const APP_LABELS = {
  portal: { label: 'Portal', icon: Icon.GCPortal },
  gateway: { label: 'Gateway', icon: Icon.GCGateway },
  modules: { label: 'Modules', icon: Icon.GCModules },
  vision: { label: 'Vision', icon: Icon.GCVision },
  academy: { label: 'Academy', icon: Icon.GCAcademy },
  conference: { label: process.env.NEXT_PUBLIC_CONFERENCE_NAV_LABEL ?? 'Conference', icon: Icon.GCConference },
} as const

export function MobileMenuNavigation() {
  const { appVariant, menuGroups, navigationTopSlot, onClose, onNavigationClick, setIsAppPickerOpen } =
    useMobileMenuContext()
  const appConfig = APP_LABELS[appVariant] || APP_LABELS.portal

  const handleItemClick = (url: string) => {
    onNavigationClick?.(url)
    onClose()
  }

  return (
    <div className={styles.navigationSection} data-testid={MOBILE_MENU_TEST_IDS.navigation}>
      <button type="button" className={styles.appHeader} onClick={() => setIsAppPickerOpen(true)}>
        <div className={styles.appHeaderContent}>
          <IconComponent icon={appConfig.icon} size={24} className={styles.appHeaderIcon} />
          <span className={styles.appHeaderLabel}>{appConfig.label}</span>
        </div>
        <IconComponent icon={Icon.ChevronRightRegular} size={20} />
      </button>

      <div className={styles.allLinksContainer}>
        {navigationTopSlot}
        <div className={styles.navItems}>
          {menuGroups.map((group) => (
            <div
              key={`${group.label ?? 'group'}-${group.items.map((item) => `${item.url}:${item.label}`).join('|')}`}
              className={styles.navGroup}
            >
              {group.label ? <div className={styles.navGroupLabel}>{group.label}</div> : null}
              {group.items.map((item) => (
                <button
                  key={`${item.url}-${item.label}-mobile`}
                  className={`${styles.navItem} ${item.active ? styles.active : ''} ${item.disabled ? styles.disabled : ''}`}
                  onClick={() => !item.disabled && handleItemClick(item.url)}
                  disabled={item.disabled}
                >
                  {item.icon ? <IconComponent icon={item.icon} size={24} className={styles.navItemIcon} /> : null}
                  <span className={styles.navItemLabel}>{item.label}</span>
                  {item.badge ? <span className={styles.navItemBadge}>{item.badge}</span> : null}
                </button>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
